import { add, format } from "date-fns";

export const CUSTOM_SEARCH = 'search';
export const CUSTOM_CURRENT = '$$current';
export const CUSTOM_NOW = '$$now';
export const PLUS = '+';
export const MINUS = '-';


const getParam=(data)=>{
  let url = '';
  for (var k in data) {
    let value = data[k] !== undefined ? data[k] : '';
    url += `&${k}=${encodeURIComponent(value)}`
  }
  return url ? url.substring(1) : ''
}

export const getAllUrl = (url, data) => {

  return url += (url.indexOf('?') < 0 ? '?' : '') + getParam(data)
}


export const uuid = () => {
  var s = [];
  var hexDigits = "0123456789abcdef";
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = "-";

  var uuid = s.join("");
  return uuid;
}
export const compare = (propertyName) => {
  return function (object1, object2) {
    var value1 = object1[propertyName];
    var value2 = object2[propertyName];
    if (value2 < value1) {
      return -1;
    } else if (value2 > value1) {
      return 1;
    } else {
      return 0;
    }
  }
}

export const stringify = (json) => {
  let count = 0;
  let list = [];
  let str = JSON.stringify(json, function (key, val) {
    if (typeof val === 'function') {
      list.push(val + '');
      const result = '$code{' + count + '}$code'
      count = count + 1;
      return result
    }
    return val;
  }, 2);
  let startCode = '$code{';
  let endCode = '}$code';
  list.forEach((ele, index) => {
    str = str.replace(startCode + index + endCode, startCode + ele + endCode)
  })
  for (let i = 0; i < count; i++) {
    str = str.replace('"' + startCode, '').replace(endCode + '"', '')
  }
  return str
}

export const parse = (str) => {
  return JSON.parse(str, function (k, v) {
    if (v.indexOf && v.indexOf('function') > -1) {
      return eval("(function(){return " + v + " })()")
    }
    return v;
  });
}
export const addUrlParam = (url, param, value) => {
  if (!url) return

  function GetQueryString(name) {
    var num = url.indexOf("?")
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    var r = url.substr(num + 1).match(reg);
    if (r != null) {
      return unescape(r[2]);
    }
    return null;
  }

  function replaceParamVal(paramName, value) {
    var re = eval('/(' + paramName + '=)([^&]*)/gi');
    return url.replace(re, paramName + '=' + value);
  }
  if (GetQueryString(param)) {
    return replaceParamVal(param, value)
  } else {
    if (url.includes('?')) {
      url = url + '&' + param + '=' + value
    } else {
      url = url + '?' + param + '=' + value
    }
    return url;
  }

}

// 获取url中的参数
export const getUrlParams = (url) => {
  let result = {
    url: '',
    params: {}
  };
  let list = url.split('?');
  result.url = list[0];
  let params = list[1];
  if (params) {
    let list = params.split('&');
    list.forEach(ele => {
      let dic = ele.split('=');
      let label = dic[0];
      let value = dic[1];
      result.params[label] = value;
    });
  }
  return result;
};

export const parseUrl = (url, obj = {}) => {
  const getParamKey = (key, v) => {
    const index = `${key}.`.length;
    return v.substring(index) || '';
  }
  const parseSearch = (key) => {
    const href = decodeURIComponent(location.href);
    const params = getUrlParams(href);
    if (params.params.hasOwnProperty(key)) {
      return params.params[key];
    } else {
      return '';
    }
  };
  const parseObj = (key) => {
    const value = key.split('.').reduce((prev, curr) => prev[curr], obj);
    return value || '';
  }
  const vars = url.match(/\{[^\\}]+\}/g);
  if (vars) {
    vars.forEach(v => {
      if (v.includes('.')) {
        const variable = v.replace('{', '').replace('}', '');
        const keys = variable.split('.');
        let value;
        if (keys[0] === CUSTOM_SEARCH) {
          const paramKey = getParamKey(CUSTOM_SEARCH, variable);
          value = parseSearch(paramKey);
        } else if (keys[0] === CUSTOM_CURRENT) {
          const paramKey = getParamKey(CUSTOM_CURRENT, variable);
          value = parseObj(paramKey);
        } else {
          value = v;
        }
        url = url.replace(v, value);
      }
    });
  }
  return url;
}

// 金额格式化
export const moneyFormat = (...args) => {
  let [value, decimals, moneyFormat] = args
  if (moneyFormat) {
    if (!value) return '';
    if (isNaN(value)) return value;
    let denominator = 10000;
    let type = '';
    let numberFormat = (value) => {
      if (!value) return '';
      let res = value.toString().replace(/\d+/, function (n) { // 先提取整数部分
        return n.replace(/(\d)(?=(\d{3})+$)/g, function ($1) {
          return $1 + ',';
        });
      })
      return res;
    }
    if (Number(value) < 0) {
      value = Math.abs(value);
      type = '-';
    }
    return type + (Math.ceil(+value) / denominator >= 1 ? Math.ceil(+value) / denominator >= 10000 ?
      Math.ceil(+value) / (denominator * 10000) >= 10000 ?
        numberFormat(`${(Math.ceil(+value) / (denominator * 10000 * 10000)).toFixed(decimals)}`) + '万亿'
        : numberFormat(`${(Math.ceil(+value) / (denominator * 10000)).toFixed(decimals)}`) + '亿'
      : numberFormat(`${(Math.ceil(+value) / denominator).toFixed(decimals)}`) + '万' : numberFormat(Math.ceil(+value)));
  } else {
    return value
  }
}

export const parseParams = params => {
  if (!params) return params;

  // $$now - 5m
  // s (seconds), m (minutes), h (hours), d (days), w (weeks), M (months), and y (years)
  const parseStr = str => {
    const formula = str.replace(CUSTOM_NOW, '').replace(/ /g, '');
    let unit = formula[formula.length - 1];
    switch (unit) {
    case 's':
      unit = 'seconds';
      break;
    case 'm':
      unit = 'minutes';
      break;
    case 'h':
      unit = 'hours';
      break;
    case 'd':
      unit = 'days';
      break;
    case 'w':
      unit = 'weeks';
      break;
    case 'M':
      unit = 'months';
      break;
    case 'y':
      unit = 'years';
      break;
    default:
      unit = 'days';
    }
    const value = formula.substring(1, formula.length - 1);
    let date = new Date();
    if (formula.startsWith(PLUS)) {
      date = add(Date.now(), { [unit]: +value });
    } else if (formula.startsWith(MINUS)) {
      date = add(new Date(), { [unit]: -Number(value) });
    }
    return format(date, "yyyy-MM-dd");
  }

  const keys = Object.keys(params);
  const result = { ...params };
  keys.forEach(key => {
    const value = `${params[key]}`.trim();
    if (value.startsWith(CUSTOM_NOW)) {
      result[key] = parseStr(value);
    }
  });
  return result;
}

export const getTopUrl = () => {
  const { protocol, host } = window.location;
  const href = `${protocol}//${host}`;

  const lastChar = href[href.length - 1];
  let result = href;
  if (lastChar === '/') {
    result = href.substring(0, href.length - 1);
  }
  return result;
}

